/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {registerLocaleData} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import {
	APP_INITIALIZER,
	ErrorHandler,
	Injectable,
	LOCALE_ID,
	NgModule,
	provideZoneChangeDetection,
} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {Router} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
	MissingTranslationHandler,
	MissingTranslationHandlerParams,
	TranslateModule,
} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/angular';
import {MessageService} from 'primeng/api';
import {providePrimeNG} from 'primeng/config';
import {DialogService} from 'primeng/dynamicdialog';
import {Toast} from 'primeng/toast';
import {NgxEchartsModule} from 'ngx-echarts';
import {NgxFilesizeModule} from 'ngx-filesize';
import {CoreModule} from './@core/core.module';
import {SessionService} from './@core/utils/session.service';
import {APP_DARK_CLASS, AppPreset} from './@theme/prime/app.preset';
import {getAppPrimeTranslation} from './@theme/prime/app-prime-locale';
import {AppPrimeLocaleService} from './@theme/prime/app-prime-locale.service';
import {AppThemeService} from './@theme/prime/app-theme.service';
import {ThemeModule} from './@theme/theme.module';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AppDrawerHostComponent} from './@theme/prime/app-drawer-host.component';
import * as echarts from 'echarts';

@Injectable()
export class MyMissingTranslationHandler implements MissingTranslationHandler {
	missing = {};

	handle(params: MissingTranslationHandlerParams): string {
		this.missing[params.key] = params.key;
		return params.key;
	}
}


registerLocaleData(localeFr);
registerLocaleData(localePt);
registerLocaleData(localeIt);

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		AppRoutingModule,
		NgxFilesizeModule,
		CoreModule.forRoot(),
		ThemeModule.forRoot(),
		TranslateModule.forRoot({
			defaultLanguage: localStorage.getItem('locale') || 'FR',
			loader: provideTranslateHttpLoader({
				prefix: './assets/trads/',
				suffix: '.json',
			}),
		}),
		FontAwesomeModule,
		NgxEchartsModule.forRoot({ echarts }),
		Toast,
		AppDrawerHostComponent,
	],
	providers: [
		provideZoneChangeDetection({eventCoalescing: true}),
		providePrimeNG({
			theme: {
				preset: AppPreset,
				options: {
					darkModeSelector: `.${APP_DARK_CLASS}`,
				},
			},
			ripple: true,
			translation: getAppPrimeTranslation(localStorage.getItem('locale') || 'FR'),
		}),
		AppPrimeLocaleService,
		MessageService,
		DialogService,
		AppThemeService,
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler({
				showDialog: false,
			}),
		},
		{
			provide: Sentry.TraceService,
			deps: [Router],
		}, {
			provide: MissingTranslationHandler,
			useClass: MyMissingTranslationHandler,
		},
		{provide: LOCALE_ID, useValue: 'fr-FR'},
		SessionService,

		{
			provide: APP_INITIALIZER,
			useFactory: () => () => {},
			deps: [Sentry.TraceService],
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {
}
